import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EventEmitterService } from 'src/app/event-emitter.service';

@Component({
  selector: 'app-timer-confirm',
  templateUrl: './timer-confirm.component.html',
  styleUrls: ['./timer-confirm.component.css']
})
export class TimerConfirmComponent implements OnInit {

  constructor(public dialog: MatDialogRef<TimerConfirmComponent>,private router:Router, private eventEmitterService: EventEmitterService ) { }

  ngOnInit() {
  }
  firstComponentFunction(){   
     
    this.dialog.close();
    this.eventEmitterService.onFirstComponentButtonClick();    
  }    
  // clickYes(){
  //   sessionStorage.setItem('timeIn','false');
   
  //   sessionStorage.removeItem('minutes');
  //   sessionStorage.removeItem('seconds');

  //   location.reload();
  // }
  clickNo(){
    
    this.dialog.close();
    sessionStorage.clear();
    this.router.navigate(["/home"])
  }
}
